export const validation = {
  name: (value: string): string => {
    if (!value || value.trim() === '') {
      return 'Введите имя'
    }

    const allowedPattern = /^[a-zA-Zа-яА-ЯёЁ\s-]+$/
    if (!allowedPattern.test(value) || value.length < 2 || value.length > 30) {
      return 'Некорректное имя'
    }

    return ''
  },

  email: (value: string): string => {
    if (!value || value.trim() === '') {
      return 'Введите email'
    }

    const emailPattern = /^([a-zA-Z0-9\-_.+]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i
    if (!emailPattern.test(value)) {
      return 'Некорректный email'
    }

    return ''
  },

  role: (value?: string): string => {
    if (!value || value.trim() === '') {
      return 'Выберите вариант'
    }

    return ''
  },

  anotherRole: (value: string, role?: string): string => {
    if (role === 'other') {
      if (!value || value.trim() === '') {
        return 'Введите вариант'
      }

      const allowedPattern = /^[a-zA-Zа-яА-ЯёЁ\s-]+$/
      if (!allowedPattern.test(value) || value.length < 2 || value.length > 30) {
        return 'Некорректный вариант'
      }
    }

    return ''
  }
}
